import Joi from 'joi';

/**
 * Schema for phone number validation.
 * @returns - A Joi string schema object. In case the value is invalid,
 * it will return an error with the key 'string.pattern.base'.
 */
export const phoneSchema = () =>
	Joi.string().pattern(new RegExp('^[+0-9 ]*$')).allow(null);
